import { Drawer, Theme, Typography, withStyles } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { Button, LoadingIcon, PopoverList, Tabs } from 'bc-front-sagacomponents';
import { TabItem } from 'bc-front-sagacomponents/lib/src/components/Tabs';
import React, { useEffect, useState } from 'react';
import { TypedUseSelectorHook, useSelector as useReduxSelector } from 'react-redux';
import Download from '../../../images/Download';
import { RootState } from '../../../redux/reducers';
import history from '../../../services/history';
import AvantageTab from '../AvantageTab';
import BlocContact from '../BlocContact';
import FideliteTab from '../FideliteTab';
import { useContrat } from '../hooks/selectors';
import InformationsTab from '../InformationsTab';
import LeftDrawer from '../LeftDrawer';
import RenouvellementTab from '../RenouvellementTab';
import styles from '../style';
import ResiliationTab from '../ResiliationTab';

interface Props {
  classes?: any;
  theme?: Theme;
}
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
const ComptePageContent = (props: Props) => {
  const { classes, theme } = props;

  const {
    fetchingPdf,
    setLaunchBulletinNumero,
    handleChangeProgramme,
    width,
    open,
    handleDrawer,
    displayLeftDrawer,
    setSelectedAdhesion,
    selectedAdhesion,
    selectLinks,
    tabs,
    listeAdhesions,
  } = useContrat();
  const params = window.location.search;
  const [tabsContent, setTabsContent] = useState<TabItem[]>();

  useEffect(() => {
    if (selectedAdhesion && selectedAdhesion.codeProgramme) {
      handleChangeProgramme(selectedAdhesion.codeProgramme);
    }
  }, [selectedAdhesion?.numeroAdhesion]);

  useEffect(() => {
    if (listeAdhesions) {
      const adhesionsSelected = listeAdhesions.find((adh) => adh.numeroAdhesion === selectedAdhesion?.numeroAdhesion);
      setSelectedAdhesion(adhesionsSelected);
    }
  }, [listeAdhesions]);

  useEffect(() => {
    const buildTabsWithContent = tabs?.map((tab) => {
      let content = <InformationsTab selectedAdhesionId={selectedAdhesion?.numeroAdhesion} />;
      if (tab.value === 'avantage') content = <AvantageTab selectedAdhesion={selectedAdhesion} />;
      else if (tab.value === 'renouvellement')
        content = (
          <RenouvellementTab
            width={width}
            selectedAdhesion={selectedAdhesion}
            theme={theme}
            // setSelectedAdhesion={setSelectedAdhesion}
            // listeAdhesions={listeAdhesions}
          />
        );
      else if (tab.value === 'resiliation') content = <ResiliationTab selectedAdhesion={selectedAdhesion} />;
      else if (tab.value === 'fidelite') content = <FideliteTab selectedAdhesion={selectedAdhesion} />;
      return {
        ...tab,
        content,
      };
    });
    setTabsContent(buildTabsWithContent);
  }, [tabs, selectedAdhesion]);
  //
  // SELECTION DE L'ONGLET EN FONCTION DE L'URL
  //
  const [selectedTab, setSelectedTab] = useState<TabItem>();
  useEffect(() => {
    if (tabsContent) {
      const selectedParams = tabsContent.find((tab) => tab && tab.value && params.includes(tab.value));
      selectedParams && setSelectedTab(selectedParams);
      const findIndex = tabsContent.find((tab) => selectedParams && tab.value === selectedParams.value);
      if (findIndex) {
        setSelectedTab(findIndex);
        history.push({
          pathname: '/contrats',
          search: params.substring(1),
        });
      } else {
        setSelectedTab(tabsContent[0]);
        history.push({
          pathname: '/contrats',
          search: 'informations',
        });
      }
    }
  }, [params, tabsContent]);

  //
  // CHANGE ONGLET AVEC CHANGEMENT DE L'URL
  //
  const changeUrl = (value) => {
    const selectedValue = tabsContent && tabsContent.find((tab) => tab.index === value);
    history.push({
      pathname: '/contrats',
      search: selectedValue && selectedValue.value,
    });
  };

  return (
    <>
      {displayLeftDrawer && (
        <LeftDrawer
          width={width}
          open={open}
          onDrawerOpen={handleDrawer}
          listeAdhesions={listeAdhesions}
          setSelectionAdhesion={setSelectedAdhesion}
          selectedAdhesion={selectedAdhesion}
          handleChangeProgramme={handleChangeProgramme}
        />
      )}
      {(selectedTab || selectedTab === 0) && (
        <div
          className={classes.content}
          style={{
            paddingLeft: open && displayLeftDrawer && width > 628 ? 200 : 0,
          }}
        >
          {' '}
          <div className={classes.title}>
            <Typography variant="h2">
              {' '}
              {selectedAdhesion?.marque ? (
                <>
                  <strong>{selectedAdhesion?.marque?.libelle + ' ' + selectedAdhesion?.modele} </strong>{' '}
                  {selectedAdhesion?.immatriculation}
                </>
              ) : (
                <>
                  <strong>Carte de fidélité </strong> N° {selectedAdhesion?.numeroFidelite}
                </>
              )}
            </Typography>
            {width > 628 ? (
              <Button
                variant="text"
                color="primary"
                title="Télécharger le contrat"
                onClick={() => setLaunchBulletinNumero(selectedAdhesion?.numeroAdhesion)}
                icon={fetchingPdf ? <LoadingIcon size="small" /> : <Download width={16} />}
              />
            ) : (
              <PopoverList
                onSelect={selectLinks}
                id={'actions-utilisateurs'}
                noArrow
                buttonName={<MoreVert color="secondary" />}
                list={[{ id: 'telechargerContrat', value: 'Télécharger contrat' }]}
              />
            )}
          </div>{' '}
          {tabsContent && <Tabs activeValue={selectedTab.index} tabs={tabsContent} onChange={changeUrl} />}
        </div>
      )}{' '}
      {params === '?renouvellement' && width > 899 && (
        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="right"
          open={true}
          classes={{
            paper: classes.drawerInformations,
          }}
        >
          <div className={classes.drawerContent}>
            <BlocContact theme={theme} />
          </div>
        </Drawer>
      )}
    </>
  );
};

export default withStyles(styles)(ComptePageContent);
